import Vue from 'vue';
import axios from 'axios';
import resetState from '@/helpers/resetState';
import CONFIG from '@/config';
import { errors, empty, formatData } from '@/constants/commonContent';

const initialState = {
  otherAssets: {},
  balance: 0,
  tempMailData: {
    waitingMember: null,
    approvedMember: null,
    sentTransfer: null,
    voting: null,
    resolvedVote: null
  }
};

const state = {
  otherAssets: initialState.otherAssets,
  balance: initialState.balance,
  tempMailData: initialState.tempMailData
};

const getters = {
  getHeaders: (state, getters) => ({
    headers: {
      'X-Address': getters.getWallet,
      'X-Token': getters.getMemberKey,
      'X-Master-Address': getters.getMasterAddress
    }
  }),
  getBalance: state => state.balance,
  getOtherAssets: state => state.otherAssets,
};

const mutations = {
  resetExternalService: state => {
    resetState(state, initialState);
  },
  setOtherAssets: (state, item) => {
    for (var attr in item) {
      Vue.set(state.otherAssets, attr, item[attr]);
    }
  },
  setBalance: (state, item) => {
    state.balance = item;
  }
};

const actions = {
  initExternalService({ dispatch, getters }) {
    dispatch('getEthereumBalanceExt', getters.getWallet);
  },
  getOtherAssetsExt({ dispatch, commit, getters }) {
    let url = CONFIG.backendURL + CONFIG.endPoints.assets;
    if (
      getters.getCompanyWallet &&
      getters.getCompanyWallet !== empty.web3.address &&
      getters.getMemberKey &&
      getters.getMemberKey !== empty.web3.bytes32
    ) {
      getAssets(getters.getMasterAddress);
      dispatch('setCompanyLinkExt', getters.getCompanyName);
    }

    function getAssets(masterAddress) {
      axios.get(url, getters.getHeaders).then(
        response => {
          commit('setOtherAssets', response.data);
        },
        error => {
          Vue.toasted.error(errors.backend.status.serverDown.infoText);
        }
      );
    }
  },
  setCompanyLinkExt({ getters }, data) {
    let url = CONFIG.backendURL + CONFIG.endPoints.companyLink;
    if (
      getters.getInitStatusOwners &&
      getters.getMemberKey &&
      getters.getMemberKey !== empty.web3.bytes32
    ) {
      createUpdateCompany();
    }

    function createUpdateCompany() {
      axios.post(url, { companyName: data }, getters.getHeaders).then(
        response => {},
        error => {
          Vue.toasted.error(errors.backend.status.serverDown.infoText);
        }
      );
    }
  },
  getEthereumBalanceExt({ commit, getters }, address) {
    CONFIG.etherscan!.balance.params.address = address;
    window.web3.eth.getBalance(address, (err, res) => {
      if (res) {
        const balance = formatData.number(formatData.fromWei(res), 5);
        commit('setBalance', balance);
      } else {
        commit('setBalance', null);
      }
    });
  },
  getStripePublicExt({ getters }): Promise<string> {
    let url = CONFIG.backendURL + CONFIG.endPoints.stripe.public;
    return axios.get(url, getters.getHeaders)
      .then(res => res.data);
  },
  purchaseStripeExt({ getters }, data): Promise<string> {
    let url = CONFIG.backendURL + CONFIG.endPoints.stripe.purchase;
    return axios.post(url, data, getters.getHeaders)
      .then(res => res.data);
  },
  sendNewMemberMailExt({ getters }, body) {
    getters.mails.newMember(body).then();
  },
  sendApproveNewMemberMailExt({ getters }, body) {
    getters.mails.approveNewMember(body).then();
  },
  sendNewVoteMailExt({ getters }, body) {
    getters.mails.voting(body).then();
  },
  sendTransferMailExt({ getters }, body) {
    getters.mails.transfer(body).then();
  },
  sendAgentTransferMailExt({ getters }, body) {
    getters.mails.agentTransfer(body).then();
  },
  sendResolveVotingMailExt({ getters }, body) {
    getters.mails.resolveVoting(body).then();
  },
  sendUploadFileMailExt({ getters }, body) {
    getters.mails.uploadFile(body).then();
  },
  sendUploadLegalMailExt({ getters }, body) {
    getters.mails.uploadLegal(body).then();
  },
  sendTradeMailExt({ getters }, body) {
    getters.mails.trade(body).then();
  },
  sendAgentTradeMailExt({ getters }, body) {
    getters.mails.agentTrade(body).then();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
